import { superFetch } from 'commons'

export const fetchOrganisations = () =>
    superFetch({ url: `organisation` })